/** Journal Entries blotter page size. Mirrors DEFAULT_PAGE_SIZE on the API. */
export const JOURNAL_ENTRIES_PAGE_SIZE = 20;

/**
 * journal_entries.source_type → a human label. Mirrors SourceType on the API.
 *
 * Only `invoice` is produced today — every wired posting hangs off an invoice. The rest appear as
 * their call sites land: `payment_method` with buy-credits, `credit_lot` with lot reversals,
 * `refund` and `payment_receipt` with the reversal family.
 */
export const SOURCE_TYPE_LABELS: Record<number, string> = {
  0: "Credit purchase",
  1: "Invoice",
  2: "Adjustment",
  3: "Transfer",
  4: "Top-up",
  5: "Credit lot",
  6: "Refund",
  7: "Payment receipt",
  8: "Redemption",
  9: "Committed credit",
};

/** Source types that have a detail view to link through to. Mirrors SourceType on the API. */
export const SOURCE_TYPE_PURCHASE = 0;
export const SOURCE_TYPE_INVOICE = 1;
/** ph2. A redemption's entries hang off the consumption event, not the contact or the campaign. */
export const SOURCE_TYPE_CONSUMPTION_EVENT = 8;
/** ph2. An admin adjustment's own entries — and, via the lot it minted, that lot's. */
export const SOURCE_TYPE_ADJUSTMENT = 2;

export const sourceTypeLabel = (t: number | null): string =>
  t == null ? "—" : (SOURCE_TYPE_LABELS[t] ?? `Type ${t}`);
